export default __webpack_public_path__ + "static/media/security_2.91ebc27f.gif";